import React, { createContext, useContext } from "react";
var GatsbyMDXScopeContext = /*#__PURE__*/createContext({});
export var useMDXScope = function useMDXScope(scope) {
  var contextScope = useContext(GatsbyMDXScopeContext);
  return scope || contextScope;
};
export var MDXScopeProvider = function MDXScopeProvider(_ref) {
  var __mdxScope = _ref.__mdxScope,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(GatsbyMDXScopeContext.Provider, {
    value: __mdxScope
  }, children);
};